import React, { useContext, useState } from 'react';
import clsx from 'clsx';

import _ from "lodash";

import {
    IconButton,    
    Input,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Tooltip
} from '@material-ui/core';

import { UserContext } from '../contexts/UserContext';

import SearchIcon from '@material-ui/icons/Search';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import TableIcon from '@material-ui/icons/TableChartOutlined';
import PencilIcon from '@material-ui/icons/EditOutlined';
import EyeIcon from '@material-ui/icons/VisibilityOutlined';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    searchAllign: {
        display: 'flex',
        alignItems: 'center',
        margin: theme.spacing(1)
    },
    search: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIcon: {
        marginRight: theme.spacing(2),
        color: theme.palette.icon
    },
    searchInput: {
        flexGrow: 1
    },
    searchButton: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(2)
    },
}));

export const TableMenu = ({ 
    disabled,
    onItemSelected,
    ...props }) => {
    const classes = useStyles();

    const {
        state: { me: userInfo }
    } = useContext(UserContext);

    const {
        tables
    } = userInfo;

    // We use lodash debounce to avoid gazillion of request
    // We use the old fashion promise way because react select + debounce 
    // seems to work well only when using promises :(
    //
    // https://github.com/JedWatson/react-select/issues/3075
    //

    const [tableFilter, setTableFilter] = useState("");
    const filterTables = _.debounce((value) => {
        setTableFilter(value);        
    }, 500);    

    const tableNameComparer = (table, name) => {
        return name.length === 0 
            || table.tableName.toLowerCase().includes(name.toLowerCase());
    }

    const [searchText, setSearchText] = useState("");
    const inputChangeHandler = (e) => {
        setSearchText(e.target.value);
        filterTables(e.target.value);
    }
    
    const clearClickHandler = () => {
        setSearchText("");   
        filterTables("");
    }

    const tableSelectedHandler = (table) => {
        if(onItemSelected) onItemSelected(table);        
    }

    return (
        <div>
            <div className={classes.searchAllign}>
                <Paper
                    className={classes.search}
                    elevation={1}>
                    <SearchIcon className={classes.searchIcon} />
                    <Input
                        className={classes.searchInput}
                        disableUnderline
                        placeholder="Search"
                        value={searchText}
                        disabled={disabled}
                        onChange={inputChangeHandler}
                    />
                    <IconButton
                        size="small"
                        disabled={disabled}
                        onClick={() => clearClickHandler()}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Paper>
            </div>
            <List className={clsx(classes.root, props.className)}>
                {tables && tables
                    .filter((table) => tableNameComparer(table, tableFilter))
                    .map((table, index) =>
                        <ListItem
                            key={index}
                            button
                            onClick={() => tableSelectedHandler(table)}>
                            <ListItemIcon>
                                <TableIcon />
                            </ListItemIcon>
                            <ListItemText primary={table.tableName} />
                            <ListItemIcon >
                                {table.roleIds.includes(1) || table.roleIds.includes(2) ?
                                        (<Tooltip title="You can view and edit this table" arrow placement="top-end"><PencilIcon /></Tooltip>) :
                                        (<Tooltip title="You can only view this table" arrow placement="top-end"><EyeIcon /></Tooltip>)}
                                </ListItemIcon>
                        </ListItem>
                    )}
            </List>
        </div>
    );
}